// extracted by mini-css-extract-plugin
module.exports = {"item":"styles_item__oKQgU","trigger":"styles_trigger__hq0yJ","content":"styles_content__8rmHj","methodChip":"styles_methodChip__2yWLW","divider":"styles_divider__4_kMJ"};